import React from 'react'

const FeatureFlagContext = React.createContext()

export default FeatureFlagContext
